import { formataNomeMeioSiglas } from './functions';
import { ILogData } from '../modules/types/LogData';

export function functionLogData(
  data: {
    id: number;
    dataRegistro: string;
    dataUltimaAtualizacao: string;
    nEdicoes: number;
    usuarioRegistro: { nomeCompleto: string };
    usuarioAtualizacao: { nomeCompleto: string };
  } | null,
): ILogData | null {
  if (!data) return null;

  return {
    id: data.id,
    usuarioRegistro: formataNomeMeioSiglas(data.usuarioRegistro.nomeCompleto),
    usuarioAtualizacao: formataNomeMeioSiglas(
      data.usuarioAtualizacao.nomeCompleto,
    ),
    dataRegistro: data.dataRegistro,
    dataAtualizacao: data.dataUltimaAtualizacao,
    nEdicoes: data.nEdicoes,
  };
}
